import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";
import { IndicatorEsfStatusEnum } from "@/utils/enums/IndicatorEsfStatusEnum";

export type DetailedCitizenScoresIndicatorC5Params = Partial<PaginationFilter> & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	isEvaluated?: boolean;
	export?: boolean;
};

export type DetailedCitizenScoresIndicatorC5Data = {
	id: number;
	cpf?: string;
	cns?: string;
	birthdate: string;
	fullName: string;
	healthUnitId: number;
	healthTeamId: number;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	lastAttendanceStatus: IndicatorEsfStatusEnum;
	lastBloodPressureMeasurementStatus: IndicatorEsfStatusEnum;
	twoHomeVisitsStatus: IndicatorEsfStatusEnum;
	lastWeightAndHeightMetricsRegisterStatus: IndicatorEsfStatusEnum;
	score: number;
};

export async function getDetailedCitizensScoresIndicatorC5({
	uf,
	ibgeCode,
	...params
}: DetailedCitizenScoresIndicatorC5Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenScoresIndicatorC5Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c5/detailed-citizens-scores`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenScoresIndicatorC5Data>();
}
